import i18n from '@/i18n'
import { SUPPORTED_LOCALES, LOCALES_REGEX } from './supportedLocales.js'

export { SUPPORTED_LOCALES, LOCALES_REGEX }

export default {
  getAllLanguageCodes() {
    return SUPPORTED_LOCALES.map(lang => lang.code)
  },

  getLocaleByCode (localeCode) {
    if (!localeCode) {
      return this.getLocaleByCode('lv')
    }

    return SUPPORTED_LOCALES.find(loc => loc.code === localeCode)
  },

  getLocale () {
    return this.getLocaleByCode(i18n.locale)
  },

  isLanguageSupported(lang){
    if (!lang){
      return false
    }
    return lang.match(LOCALES_REGEX)
  }
}
